import getMessageLogWidgetConfig from '../../GroupWidgets.deviation_gruser/MessageLog/widgetConfig';
import getActionLogWidgetConfig from '../../GroupWidgets.deviation_gruser/ActionLog/widgetConfig';
import getGroupNotesWidgetConfig from '../../GroupWidgets.deviation_gruser/GroupNotes/widgetConfig';

export const getBackroomWidgetConfigs = ({ t, dispatch }) =>
  ({
    groupMessagelog: getMessageLogWidgetConfig({ t, dispatch }),
    groupActionlog: getActionLogWidgetConfig({ t, dispatch }),
    groupNotes: getGroupNotesWidgetConfig({ t, dispatch }),
  } as any);

export default getBackroomWidgetConfigs;
